import React, { useContext } from 'react'
import { Collapse, List } from '@chakra-ui/react'
import { CollapsibleButton } from 'chemistry'
import { GroupedAttributesList } from './GroupedAttributesList'
import { AttributesList } from './AttributesList'
import { TranslateContext } from 'client/common/translator'

const ProductAttributesList = ({
  attributes,
  visibleFiltersCount,
  isAttributesClustered,
  pimAttributesTranslations,
  lang,
  isOpen,
  setIsOpen
}) => {
  const t = useContext(TranslateContext)
  const list = isAttributesClustered
    ? GroupedAttributesList({ attributes, pimAttributesTranslations, lang })
    : AttributesList({ attributes, pimAttributesTranslations, lang })

  const { initial: initialItems, hidden: hiddenItems } = list.reduce(
    ({ initial, hidden }, attr) => {
      if (initial.length < visibleFiltersCount) {
        return {
          initial: initial.concat(attr),
          hidden
        }
      }
      return {
        initial,
        hidden: hidden.concat(attr)
      }
    },
    { initial: [], hidden: [] }
  )

  return (
    <>
      <List className='p0'>
        {initialItems}
        <Collapse in={isOpen} unmountOnExit>
          {hiddenItems}
        </Collapse>
      </List>
      <CollapsibleButton
        visibleFiltersCount={visibleFiltersCount}
        itemsCount={list?.length}
        onClick={setIsOpen}
        expanded={isOpen}
        title={t('product_show_more')}
        buttonActiveText={t('product_show_less')}
        buttonInactiveText=''
      />
    </>
  )
}

export default ProductAttributesList
